function e(...n){return n.filter(Boolean).join(" ")}export{e as classNames};
